import { render, staticRenderFns } from "./myUpload.vue?vue&type=template&id=46d86588&scoped=true"
import script from "./myUpload.vue?vue&type=script&lang=js"
export * from "./myUpload.vue?vue&type=script&lang=js"
import style0 from "./myUpload.vue?vue&type=style&index=0&id=46d86588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d86588",
  null
  
)

export default component.exports